/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lifecycle_Impact_TrashedInputs */

const en_lifecycle_impact_trashed = /** @type {(inputs: Lifecycle_Impact_TrashedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In the trash: ${i?.count}`)
};

const de_lifecycle_impact_trashed = /** @type {(inputs: Lifecycle_Impact_TrashedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Im Papierkorb: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "In the trash: {count}" |
*
* @param {Lifecycle_Impact_TrashedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_impact_trashed = /** @type {((inputs: Lifecycle_Impact_TrashedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Impact_TrashedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_impact_trashed(inputs)
	return en_lifecycle_impact_trashed(inputs)
});